import useWaitingMutation from '@hooks/useWaitingMutation';
import { softDeleteSubmission } from '@services/submissionService';

export const useSoftDeleteSubmission = () => {
  const { mutate, isLoading } = useWaitingMutation((submissionId: number) => softDeleteSubmission(submissionId));

  return { removeSubmission: mutate, isRemovingSubmission: isLoading };
};
